import Cookies from "js-cookie";
import { format } from "date-fns";

export const getActiveWebsiteId = (currentWebsiteId) => {
	const fromContext = parseInt(currentWebsiteId, 10);
	if (Number.isFinite(fromContext) && fromContext > 0) {
		return fromContext;
	}
	const fromCookie = parseInt(Cookies.get("_website_id"), 10);
	if (Number.isFinite(fromCookie) && fromCookie > 0) {
		return fromCookie;
	}
	return null;
};

export const buildReportRequestPayload = (currentWebsiteId, dateRange, extras = {}) => {
	const websiteId = getActiveWebsiteId(currentWebsiteId);
	if (!websiteId) {
		return null;
	}
	return {
		websiteId,
		startDate: format(dateRange.startDate, "yyyy-MM-dd"),
		endDate: format(dateRange.endDate, "yyyy-MM-dd"),
		...extras,
	};
};
